import {
  BLImport,
  BlImportResponse,
} from "../../../interfaces/bl-import/blImport.interface";
import { IconFileDownload, IconFileUpload } from "@tabler/icons-react";
import { CustomIconButton } from "../../../components/common/icon-buttons/CustomIconButton";
import { format } from "date-fns";
import EnableEcasCheckbox from "../components/EnableEcasCheckbox";
const adminOnly = "[admin_only]";

/**
 * Generates the rows of the table BL Import.
 *
 * @param {boolean} isAdminUser - Indicates if the logged user is admin
 * @param handleDownloadBl - Method that performs the BL file download
 * @param handleDownloadActa - Method that performs the ACTA file download
 * @param handleUploadDocument - Method that performs the BL/Carta file upload
 * @param handleUploadEcas - Method that performs the ECAS file upload
 * @param handleDownloadCarta - Method that performs the CARTA file download
 * @param tableOffset - The offset of the table to infer the number of the each row
 * @param {BlImportResponse} data - The data with all bls
 * @returns {[]} Array with the table rows
 */
export const generateRowsBlImp = (
  isAdminUser: boolean,
  handleDownloadBl: (bl: BLImport) => void,
  handleDownloadActa: (bl: BLImport) => void,
  handleUploadDocument: (id: number) => void,
  handleUploadEcas: (id: number) => void,
  handleDownloadCarta: (bl: BLImport) => void,
  handleDownloadEcas: (bl: BLImport) => void,
  tableOffset: number,
  callback: () => void,
  data?: BlImportResponse
): any[] => {
  return (
    data?.data?.map((bl, index) => ({
      number: index + 1 + tableOffset,
      id: String(bl.id),
      hbl: bl.hbl,
      embarcador: bl.embarcador,
      origen: bl.origen,
      eta: formatDate(bl.eta),
      mrn: bl.mrn,
      fecha_descarga:
        isAdminUser === true ? formatDate(bl.fecha_descarga) : adminOnly,
      local_client: isAdminUser === true ? bl.local_client : adminOnly,
      ruc_local_client: isAdminUser === true ? bl.ruc_local_client : adminOnly,
      download_bl: (
        <CustomIconButton
          toolTipText="Descargar BL"
          icon={<IconFileDownload color="limegreen" />}
          onClick={() => handleDownloadBl(bl)}
          disabled={Boolean(bl.puede_descargar === false || !bl.nombre_archivo)}
        />
      ),
      descargar_acta:
        isAdminUser === true ? (
          <CustomIconButton
            toolTipText="Descargar Acta"
            icon={<IconFileDownload color="limegreen" />}
            onClick={() => handleDownloadActa(bl!)}
            disabled={Boolean(
              bl.puede_descargar === true || !bl.id_usuario_descarga
            )}
          />
        ) : (
          adminOnly
        ),
      download_carta: (
        <CustomIconButton
          disabled={!Boolean(bl.tiene_carta)}
          toolTipText="Descargar CARTA"
          icon={<IconFileDownload color="#FF8787" />}
          onClick={() => handleDownloadCarta(bl)}
        />
      ),
      download_ecas: (
        <CustomIconButton
          disabled={isDisableDownloadEcas(bl)}
          toolTipText="Descargar ECAS"
          icon={<IconFileDownload color="#9376E0" />}
          onClick={() => {
            handleDownloadEcas(bl);
          }}
        />
      ),
      upload_document:
        isAdminUser === true ? (
          <CustomIconButton
            toolTipText="Subir Documento"
            icon={<IconFileUpload color="dodgerblue" />}
            onClick={() => handleUploadDocument(bl.id!)}
          />
        ) : (
          adminOnly
        ),
      upload_ecas:
        isAdminUser === true ? (
          <CustomIconButton
            toolTipText="Subir ECAS"
            icon={<IconFileUpload color="#864AF9" />}
            onClick={() => handleUploadEcas(bl.id!)}
          />
        ) : (
          adminOnly
        ),
      enable_ecas:
        isAdminUser === true ? (
          <EnableEcasCheckbox
            disabled={isDisableEnableEcas(bl)}
            bl={bl}
            callback={callback}
          />
        ) : (
          adminOnly
        ),
    })) || []
  );
};

/**
 * Formats the given date in day-month-year format
 *
 * @param {string} date - The date to format
 * @returns
 */
function formatDate(date?: string) {
  if (date === undefined || date === "" || date === null) return "";
  try {
    return format(new Date(date), "dd/MM/yyyy");
  } catch (error) {
    return "";
  }
}

/**
 * Checks if the Download ECAS option is disabled or not.
 *
 * Returns a boolean
 *
 * @param {BLImport} bl - The Bl to check
 * @returns
 */
function isDisableDownloadEcas(bl: BLImport) {
  if (
    bl.puede_descargar_ecas === undefined ||
    bl.puede_descargar_ecas === null
  ) {
    return true;
  }
  if (bl.nombre_archivo_ecas === undefined || bl.nombre_archivo_ecas === null) {
    return true;
  }
  if (bl.puede_descargar_ecas === true && bl.nombre_archivo_ecas.length > 0) {
    return false;
  }
  return true;
}

function isDisableEnableEcas(bl: BLImport) {
  if (bl.nombre_archivo_ecas === null || bl.nombre_archivo_ecas === undefined) {
    return true;
  }
  if (bl.nombre_archivo_ecas.length <= 0) {
    return true;
  }
  return false;
}
